(function () {
    function lhm_initMasonryGalerieSection(section) {
        const triggers = Array.from(section.querySelectorAll('.galerieLightboxTrigger'));

        triggers.forEach((trigger, index) => {
            trigger.addEventListener('click', () => {
                window.lhm_openLightbox(triggers, index, trigger);
            });
        });
    }

    function lhm_initMasonryGalerie() {
        document.querySelectorAll('.layoutMasonryGalerie').forEach(lhm_initMasonryGalerieSection);
    }

    window.addEventListener('load', lhm_initMasonryGalerie);
})();
